import React from 'react';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

const PatientMessages: React.FC = () => {

  return <div>{<NotFoundPage />}</div>;
};

export default PatientMessages;
